<template>
    <div id="app">
        <div class="whitebg">

            <Menu></Menu>
            <div style="min-height: 100vh;" :class="{init:placeholder}" class="wrap">

                <div class="placeholder" :class="{init:placeholder}"></div>
                <!--<div class="placeholder" v-if=""></div>-->
                <transition name='delayfade' mode="out-in" style="min-height: 100vh;">

                    <router-view/>
                </transition>

            </div>
            <Foot></Foot>

        </div>
    </div>
</template>

<script>
    import store from '@/store/index'

    export default {
        store,
        name: 'App',
        components: {
            Foot: () => import('@/components/parts/Footer'),
            Menu: () => import('@/components/parts/Menu'),
        },
        data() {
            return {
                init: false
            }
        },
        computed: {

            page() {
                return store.state.page
            },
            routeslug() {
                return this.$route.params.slug
            },
            placeholder() {
                return !store.state.page.title && !store.state.kurs.title && !store.state.therapie.title
            },
            title() {
                if (store.state.kurs.title) {

                    return store.state.kurs.title.rendered
                }
                else if (store.state.therapie.title) {

                    return store.state.therapie.title.rendered
                }
                if (this.page.meta) {
                    // console.log(store.state.page.meta['_seopress_titles_title'][0])
                    if (this.page.meta['_seopress_titles_title']) {

                        return this.page.meta['_seopress_titles_title'][0] != '' ? this.page.meta['_seopress_titles_title'][0] : store.state.page.title.rendered
                    } else {
                        // console.log('else')

                        return this.page.title.rendered
                    }
                    // return store.state.page.meta['_seopress_titles_title'][0]!=='' ? store.state.page.meta['_seopress_titles_title'][0] : (store.state.page.title ? store.state.page.title.rendered : '')
                } else return this.page.title ? this.page.title.rendered : ''
            },
            description() {

                return ''
            }
        },
        metaInfo() {
            return {
                title: this.title,
                titleTemplate: (titleChunk) => {
                    // If undefined or blank then we don't need the hyphen

                    return titleChunk && this.$route.name !== "Start" ? `${titleChunk} - Sport- & Physiotherapie 2Perform` : 'Sport- & Physiotherapie 2Perform';
                },

            }
        },
        created() {
            store.dispatch('getAll')
            store.dispatch('getTermgroups')
            store.dispatch('getLCats')
            store.dispatch('getKCats')
            store.dispatch('getLTypes')
        },
        updated() {
            setTimeout(function () {
                this.init = true;
            }.bind(this), 100)

        },
        watch: {
            $route() {
                this.scrollToTop()
                // store.commit('emptyPage')
            }
        },

    }
</script>

<style lang="scss" type="text/scss">
    .wrap {
        /*transform: translateY(0px);*/
        /*transition: all 0.1s ease;*/

        /*&.init {*/
        /*transition: all 0.1s linear;*/

        /*}*/
    }

    .placeholder {

        /*transition: all 0.5s linear 1s;*/
        background-color: $blue;
        width: 100%;
        height: 80px;
        position: absolute;

        transition: all 0.1s ease;

        &.init {
            transition: all 0s linear;
            opacity: 1;


            /*opacity: 0.2;*/
          background-color: $blue;
   //         background-image: url("https://friedl-physio.zzagentur.de/dateien/2018/06/Header_placeholder.jpg");
            background-position: left -30vh, right -10vh;
            /*background-size: 40%;*/
            background-repeat: no-repeat;
        }


    }

    /*.delayfade-enter-active, .delayfade-leave-active {*/
    /*!*transition: opacity .5s;*!*/
    /*}*/

    /*.delayfade-enter, .delayfade-leave-to !* .fade-leave-active below version 2.1.8 *!*/
    /*{*/
    /*opacity: 0;*/
    /*}*/

    #app {
        color: #333;
        font-family: $font;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        font-size: 14px;
        background-color: #fff;
        line-height: 23px;
        letter-spacing: 0.1em;
        background-image: url('assets/2perform_Berg-ICON_RGB.svg'), url('assets/2perform_Berg-ICON_RGB.svg');
        @include mobile {
            background-image: unset;
            font-size: 13px;
            line-height: 20px;
            padding-top: 80px;
        }
        background-position: left 120vh, right 200vh;
        background-size: 30%;
        background-repeat: no-repeat;

        a {

        }

        .whitebg {
            background-color: rgba(#fff, 0.9);
        }

    }

    .fa-icon {
        width: auto;
        height: 1em; /* or any other relative font sizes */
        /* You would have to include the following two lines to make this work in Safari */
        max-width: 100%;
        max-height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue